import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  intro: {
    width: '100%',
    marginBottom: 24,
  },
  introTitle: {
    marginBottom: 18,
  },
  border: {
    width: '60%',
    border: `1px solid ${theme.palette.secondary.light}`,
    marginTop: 24,
    margin: 'auto',
  },
  iconTask: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
}))

export default useStyles
